<template>
    <body class="print">
        <main class="print-report customized">
            <div class="print__inner">
                <section class="print__section">
                    <div class="print__header">
                        <h2 class="print__title">
                            {{ props?.typeLevLes }}
                            <!-- <span class="subject">{{ summaryData?.area }}</span>  -->
                        </h2>
                        <div class="print__info"><q-icon name="calendar_today" /> {{ moment().format('YYYY-MM-DD') }}</div>
                    </div>
                    <div class="print__body">
                        <div class="print--top">
                            <div class="dashboard__content" style="width: 1600px">
                                <div class="dashboard__title">
                                    <!-- <p class="txt">{{ globalStore.userInfo.schoolName }} {{ globalStore.userInfo.grade }}학년</p> -->
                                    <p class="txt">{{ comSchoolAndGrade }}</p>
                                    <h3 class="title">
                                        {{ comUserName }}님의 독해력은
                                        <!-- <h3 class="title">{{ globalStore.userInfo.studentName }}님의 독해력은  -->
                                        <span class="level">{{ summaryData?.totalAccuracyRate > 80 ? '우수한' : summaryData?.totalAccuracyRate > 50 ? '평균' : '낮은' }} 수준입니다.</span>
                                    </h3>
                                </div>
                                <div class="dashboard__graph chart" style="height: 220px">
                                    <!-- 그래프 넣어주세요. -->
                                    <GaugeChart v-if="summaryData?.totalAccuracyRate" :chartData="summaryData?.totalAccuracyRate" header="독해력" :isDailyPrint="isDailyPrint" />
                                </div>
                            </div>
                            <div class="panel dashboard__content" v-if="summaryData">
                                <div class="customized__graph">
                                    <p class="dashboard__info">
                                        <span class="subject">코어독해</span>
                                        <span class="percent">{{ summaryData.coreResult }}%</span>
                                    </p>
                                    <div class="bar__graph">
                                        <!-- 그래프 넣어주세요. -->
                                        <q-linear-progress rounded size="lg" :value="summaryData.coreResult / 100" color="primary" />
                                    </div>
                                </div>
                                <div class="customized__graph">
                                    <p class="dashboard__info">
                                        <span class="subject">본격독해</span>
                                        <span class="percent">{{ summaryData.earnestResult }}%</span>
                                    </p>
                                    <div class="bar__graph">
                                        <!-- 그래프 넣어주세요. -->
                                        <q-linear-progress rounded size="lg" :value="summaryData.earnestResult / 100" color="primary" />
                                    </div>
                                </div>
                                <div class="customized__graph">
                                    <p class="dashboard__info">
                                        <span class="subject">어휘학습</span>
                                        <span class="percent">{{ summaryData.vocabularyResult }}%</span>
                                    </p>
                                    <div class="bar__graph">
                                        <!-- 그래프 넣어주세요. -->
                                        <q-linear-progress rounded size="lg" :value="summaryData.vocabularyResult / 100" color="primary" />
                                    </div>
                                </div>
                            </div>
                            <p class="reference__title"><span class="required">*</span>독해력이란?</p>
                            <p class="reference__txt">지문을 적정 시간에 정확하게 읽고, 이해하여 문제를 해결할 수 있는 능력</p>
                        </div>
                        <div class="print__content">
                            <h4 class="content__title">{{ summaryData?.area }} 학습 분석 결과</h4>
                            <div class="content__body">
                                <div class="result__item-title">
                                    <p class="result__title">사고 유형별<span class="required">*</span> 강약점</p>
                                    <p class="result__title">질문 유형별 강약점</p>
                                </div>
                                <div class="result__content">
                                    <div class="panel result__item">
                                        <p class="result-detail">
                                            <span class="grade">우수</span>
                                            <span class="subject">{{ analysisResult?.analysisType?.strong ? analysisResult?.analysisType?.strong : '우수한 유형이 없어요.' }}</span>
                                        </p>
                                        <p class="result-detail">
                                            <span class="grade">취약</span>
                                            <span class="subject">{{ analysisResult?.analysisType?.week ? analysisResult?.analysisType?.week : '취약한 유형이 없어요.' }}</span>
                                        </p>
                                    </div>
                                    <div class="panel result__item">
                                        <p class="result-detail">
                                            <span class="grade">우수</span>
                                            <span class="subject"> {{ analysisResult?.problemType?.strong ? analysisResult?.problemType?.strong : '우수한 유형이 없어요.' }} </span>
                                        </p>
                                        <p class="result-detail">
                                            <span class="grade">취약</span>
                                            <span class="subject">{{ analysisResult?.problemType?.week ? analysisResult?.problemType?.week : '취약한 유형이 없어요.' }}</span>
                                        </p>
                                    </div>
                                </div>
                                <p class="detail__txt bold" v-html="analysisResult?.finalComment"></p>
                                <div class="reference">
                                    <p class="reference__title"><span class="required">*</span>사고 유형</p>
                                    <p class="reference__txt">
                                        사실적독해 : 글에 표면적으로 드러난 정보를 파악하여 글의 내용을 체계적으로 이해하는 능력​<br />
                                        추론적독해 : 생략된 정보를 추론하고, 글에 드러난 단서를 근거로 글쓴이의 의도나 목적을 추측하는 능력​<br />
                                        비판적독해 : 글에 사용된 자료가 정확한지, 글쓴이의 주장이나 의견이 타당한지 점검하며 글을 읽는 능력​<br />
                                        감상적독해 : 글에서 공감하거나 감동적인 부분을 읽고 글에 담긴 가치를 종합적으로 이해하는 능력​<br />
                                        개념 : 개념을 적용하여 글을 이해하고 판단하는 능력​<br />
                                        어휘 : 글에 나온 어휘의 의미를 알고 문맥에 맞게 사용하며 적용할 수 있는 능력​
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="print__section" v-for="(item, index) in passageList">
                    <div class="print__content">
                        <h4 class="content__title" v-if="index === 0">학습 상세 내역</h4>
                        <p class="subject-detail">
                            <span class="chip">지문 {{ index + 1 }}</span>
                            {{ item?.topic }}
                        </p>
                        <div class="content__header">
                            <h5 class="content__title">{{ item.passageName }}</h5>
                            <div class="date__content">
                                <p class="kread-data" v-if="item?.kreadScore">
                                    <img src="@/assets/images/main/kread.svg" class="kread-logo" alt="KRead logo" />
                                    <span class="kread-number">{{ item?.kreadScore }}</span>
                                </p>
                                <p class="rate-data">성취율 {{ item.accuracyRate }}%</p>
                            </div>
                        </div>
                        <div class="content__body">
                            <div class="content__section">
                                <div class="detail__header">
                                    <h6 class="report__title">코어독해</h6>
                                    <p class="run-time">학습 시간 : {{ getTimeStringSecondsKor(item?.coreElapsedTime) }}</p>
                                </div>
                                <div class="detail__body">
                                    <div class="detail__section">
                                        <h5 class="detail__title">지문 읽기 활동</h5>
                                        <table class="detail__table my-reading__table">
                                            <thead>
                                                <tr>
                                                    <th>나의 읽기 시간</th>
                                                    <th>결과</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        <div>
                                                            <b>{{ getTimeStringSecondsKor(item.coreResult.readingResult.passageReadTime) }}</b>
                                                            <div>권장 읽기 시간: {{ getTimeStringSecondsKor(item.coreResult.readingResult.solveTime) }}</div>
                                                        </div>
                                                    </td>

                                                    <!-- <td>
                            <span class="run-time">{{
                                getTimeStringSecondsKor(item.coreResult.readingResult.passageReadTime)
                            }}</span>
                            <span class="standard">권장 읽기 시간 : {{
                                getTimeStringSecondsKor(item.coreResult.readingResult.solveTime)
                            }}</span>
                          </td> -->
                                                    <td :class="getReadTimeMsg(item.coreResult.readingResult) !== '시간 준수' ? 'over-time' : ''">{{ getReadTimeMsg(item.coreResult.readingResult) }}</td>
                                                    <!-- <td class="over-time">{{ (item.coreResult.readingResult.passageReadTimeMs) < 30
                              ? '주의' : (item.coreResult.readingResult.passageReadTimeMs) >
                                item.coreResult.readingResult.solveTime ? '시간 초과' :
                                '시간 준수'
                          }}</td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="detail__section">
                                        <h5 class="detail__title">지문 이해 활동</h5>
                                        <table class="detail__table">
                                            <thead>
                                                <tr>
                                                    <th>내용</th>
                                                    <th>정답여부</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="tData in item.coreResult?.understandingResult">
                                                    <td class="content">{{ tData.content }}</td>
                                                    <td>
                                                        <span :class="tData.content.indexOf('구조화') !== -1 ? '' : 'correct' + tData.correctCode">{{ tData.content.indexOf('구조화') !== -1 ? '완료' : '' }}</span>
                                                        <!-- <span :class="'correct' + tItems.correctCode">{{ tData.content.indexOf('구조화') !== -1 ? '완료' : ''
                            }} </span> -->
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="content__section">
                                <div class="detail__header">
                                    <h6 class="report__title">본격독해</h6>
                                    <p class="run-time">학습 시간 : {{ getTimeStringSecondsKor(item?.earnestElapsedTime) }}</p>
                                </div>
                                <div class="detail__body">
                                    <table class="detail__table reading__table">
                                        <thead>
                                            <tr>
                                                <th>유형</th>
                                                <th>학습 개념 상세</th>
                                                <th>문항난이도</th>
                                                <th>정답여부</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="vData in Object.values(item.earnestResultList)">
                                                <tr v-for="(tItems, index) in vData">
                                                    <td v-if="index === 0" class="text-left" :rowspan="vData.length">
                                                        {{ tItems.analysisName }}
                                                    </td>
                                                    <td class="content">
                                                        <div style="display: flex; flex-direction: row; align-items: center">
                                                            <span class="standard" style="margin-right: 0.3vw">{{ tItems.problemClassCode === '1' ? '기준문제' : '드릴문제' }}</span>
                                                            <q-icon v-if="tItems.important === 'Y'" :name="'img:/assets/images/icon/ic_important.svg'" class="important"></q-icon>
                                                        </div>
                                                        {{ tItems.learningConceptDetailName }}
                                                    </td>
                                                    <td>
                                                        <span :class="tItems.difficultCode === '04' ? 'core' : tItems.difficultCode === '05' ? 'killer' : 'basic'">
                                                            {{ difficult[tItems.difficultCode]?.label }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span :class="'correct' + tItems.correctCode">정답 </span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="content__section">
                                <div class="detail__header">
                                    <h6 class="report__title">어휘학습</h6>
                                    <p class="run-time">학습 시간 : {{ getTimeStringSecondsKor(item.vocabularyElapsedTime) }}</p>
                                </div>
                                <div class="detail__body">
                                    <table class="detail__table">
                                        <thead>
                                            <tr>
                                                <th>내용</th>
                                                <th>정답여부</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tData, index) in item?.vocabularyResultList">
                                                <td class="content">
                                                    {{ tData.content }}
                                                </td>
                                                <td>
                                                    <span :class="'correct' + tData.correctCode">정답 </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- <section>
        </section> -->
            </div>
        </main>
    </body>
</template>

<script setup>
import GaugeChart from '@/components/chart/gaugeChart.vue';
import { onMounted, ref, watch, computed } from 'vue';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, timeStringSecondsKorToSec } from '@/helpers/utils';
import { useRouter } from 'vue-router';
import { analysisOrd, difficult, learningType } from '@/helpers/qbankParser/qbankMeta';
import moment from 'moment';
import { useQuasar } from 'quasar';

import Comm from '@/components/common.js';
const user = ref(null);
const globalStore = GlobalStore();
const summaryData = ref(null);
const passageList = ref([]);
const analysisResult = ref({});
const isDailyPrint = ref(true);

const props = defineProps({
    reportData: {
        default: null,
    },
    typeLevLes: {
        default: null,
    },
});

const comUserName = computed(() => {
    return Comm.getStrName();
});
const comSchoolAndGrade = computed(() => {
    return Comm.getStrSchoolAndGrade();
});
const getReadTimeMsg = (item) => {
    if (item.passageReadTime > item.solveTime) {
        return '시간 초과';
    } else if (item.passageReadTime < 30) {
        if (item.solveTime === 60 && item.etcCd02 === '05') {
            return '시간 준수';
        } else {
            return '주의';
        }
    } else {
        return '시간 준수';
    }
};

onMounted(() => {
    if (props.reportData) {
        passageList.value = [];
        const rs = props.reportData;
        summaryData.value = {
            totalAccuracyRate: rs.totalAccuracyRate,
            coreResult: rs.totalLearningResult.coreResult,
            earnestResult: rs.totalLearningResult.earnestResult,
            vocabularyResult: rs.totalLearningResult.vocabularyResult,
            area: rs.areaCode === '02' ? '비문학' : '문학',
        };
        analysisResult.value = rs.analysisResult;
        // 본격독해 그리기 위한 데이터 변경
        rs.passageList.forEach((ei) => {
            let tmpItems = ei;
            let tmpEarnestResultList = {};
            ei.earnestResultList.forEach((eii) => {
                let temp = tmpEarnestResultList[analysisOrd[eii.analysisId]] ? tmpEarnestResultList[analysisOrd[eii.analysisId]] : [];
                temp = [...temp, eii];
                tmpEarnestResultList = { ...tmpEarnestResultList, [analysisOrd[eii.analysisId]]: temp };
            });
            tmpItems = { ...tmpItems, earnestResultList: tmpEarnestResultList };
            passageList.value = [...passageList.value, tmpItems];
        });
        // console.log(passageList.value);
        // passageList.value = rs.passageList
        // console.log(_.isEmpty(globalStore.userInfo));
        if (_.isEmpty(globalStore.userInfo)) {
            globalStore.getUserInfo();
            // console.log(globalStore.getUserInfo());
        }
        user.value = globalStore.userInfo;
    }
});
</script>

<style scoped lang="scss">
@import '../print.scss';

::v-deep {
    .customized .dashboard__graph.chart {
        background: #e0e0e0;
    }

    .customized .dashboard__graph.chart .chart__wrap {
        align-items: center;
        width: 350px;
    }

    .customized .dashboard__graph.chart .chart__label {
        margin-top: 100px;
        position: relative;
    }
    .customized .dashboard__graph.chart .chart__label::after {
        content: '*';
        position: absolute;
        top: 0;
        right: -15px;
        font-weight: 700;
        color: $color_primary;
        // line-height: 16px;
    }
    .customized .dashboard__graph.chart .chart__label .q-icon {
        display: none;
    }
}
.kread-logo {
    margin-right: 1vw;
}
.rate-flex {
    white-space: nowrap;
}
.important {
    margin-top: -2px;
    width: 1.6vmin;
    height: 1.6vmin;
}
</style>
